<template>
  <div :class="$style['LAB_SAMPLES_RECEIVED']">
    <pt-form-item label="是否正常：" labelWidth="120px" :required="true">
      <el-radio-group v-model="form.result" name="result" v-validate="'required'" data-vv-as="是否正常">
        <el-radio label="QUALIFIED">正常</el-radio>
        <el-radio label="NOT_QUALIFIED">异常</el-radio>
      </el-radio-group>
    </pt-form-item>
    <pt-form-item label="选择原因：" labelWidth="120px" v-if="form.result !== 'QUALIFIED'" :required="true">
      <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.reason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
    </pt-form-item>
    <pt-form-item label="快递单号：" labelWidth="120px">
      <div v-for="(item,i) in form.courierNumber" :key="i">
        <el-input placeholder="请填写快递单号" v-model="item.value" :class="'courier_'+i"></el-input>
        <el-button style="margin-left:10px" type="text" @click="deleteItem(i)">删除</el-button><br>
        <el-button type="text" @click="addItem(i)" v-show="i==form.courierNumber.length-1">添加一条</el-button>
      </div>
    </pt-form-item>
  </div>
</template>

<script>
import wtUploadFile from 'cps/base/wt-ui/wt-upload-file'

// import orderDatas from '@/store/actions/datas/order'
import {
  validate
} from 'utils/validate'
import {
  next
} from '../status.js'
const AbnormalReasonType = 'LAB_SAMPLES_RECEIVED__UNQUALIFIED_REASON'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  components: {
    wtUploadFile
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    isUCAS () {
      return this.$store.state.saasConfig.tenant === 'ucas'
    },
    // 是否需初始排版
    isSelectPlate () {
      return !this.order.customerBoardNumber
    }
  },
  data () {
    return {
      curparams: {},
      options: [],
      title: '样本接收',
      form: {
        result: 'QUALIFIED',
        reason: '',
        courierNumber: [{ value: '' }],
        samplePlate: 'QUALIFIED_CREATE_NEW_SAMPLE_BOARD',
        assignMode: this.order.customerBoardNumber ? 'KEEP' : 'AUTO'
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      },
      reasonProps: {
        label: 'name',
        value: 'id'
      },
      showDialog: false,
      dialog_title: '选择样本板',
      selectMaterials_info: [],
      layoutData: null,
      pictureUrl: [],
      picture_params: {
        resourceName: 'order',
        objectId: this.order.id
      }
    }
  },
  methods: {
    toSelectSamplePlate () {
      // console.log('--------------')
    },
    formValidata () {
      return validate(this, this.form)
    },
    addItem (index) {
      if (this.form.courierNumber[index].value === '') {
        this.$message.error('请填写快递单号！')
        return
      }
      this.form.courierNumber.push({ value: '' })
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.form.courierNumber.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条快递吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.courierNumber.splice(index, 1)
      })
    },
    getReason (val) {
      for (var i in this.options) {
        if (this.options[i].id === val) {
          return this.options[i].name
        }
      }
    },
    next () {
      let expressIds = this.form.courierNumber.map(res => {
        return res.value
      })
      let data = {
        orderIds: [this.order.id],
        billId: this.order.billId,
        action: this.status
      }
      // 不合格
      if (this.form.result === 'NOT_QUALIFIED') {
        data.orderStatusDetail = {
          expressIds: expressIds,
          orderStatusResult: this.form.result,
          reason: this.getReason(this.form.reason) ? this.getReason(this.form.reason) : this.form.reason,
          comment: this.form.comment
        }
        let fileObj = []
        if (this.pictureUrl.length) {
          fileObj = this.pictureUrl.map(item => ({
            ossUrl: item.path,
            type: 'IMAGE_FILE_DATA'
          }))
          data.orderStatusDetail.attachmentFileInformationList = fileObj
        }
        let params = {
          type: AbnormalReasonType,
          value: this.getReason(this.form.reason) ? this.getReason(this.form.reason) : this.form.reason,
          options: this.options
        }
        this.$emit('add-abnormalReason', params)
      } else {
        // 使用isUCAS作为开关，如果是非佳安租户的使用自定义的实验室唯一码，佳安租户使用自动分配的逻辑
        // if (this.isUCAS) {
        //   data.labCodes = [{
        //     orderId: this.order.id,
        //     labCode: this.form.labCode
        //   }]
        // }
        // 合格的情况
        data.orderStatusDetail = {
          expressIds: expressIds,
          orderStatusResult: this.form.result,
          assignMode: this.form.assignMode,
          comment: this.form.comment
        }
        let fileObj = []
        if (this.pictureUrl.length) {
          fileObj = this.pictureUrl.map(item => ({
            ossUrl: item.path,
            type: 'IMAGE_FILE_DATA'
          }))
          // fileObj.ossUrl = this.pictureUrl
          data.orderStatusDetail.attachmentFileInformationList = fileObj
        }
        if (this.form.samplePlate === 'QUALIFIED_USE_EXIST_SAMPLE_BOARD') {
          data.orderStatusDetail = {
            orderStatusResult: this.form.samplePlate,
            reactionPlateId: this.form.reactionPlateId,
            assignMode: this.form.assignMode
          }
        }
      }
      // data.orderStatusDetail.expressIds = this.form.courierNumber.map(e => e.value)
      return next.call(this, data)
    },
    getAbnormalReason () {
      this.$store.dispatch('getAbnormalReason', AbnormalReasonType).then(res => {
        this.options = res
        this.getReason()
      })
    },
    openDialog () {
      this.showDialog = true
      this.curparams = {
        chipModelDTO: {
          attributes: {
            method: {
              chipType: this.order.product.method.chipType
            }
          }
        }
      }
    },
    closeDialog () {
      this.showDialog = false
    },
    getDatalList (val) {
      // this.layoutData = orderDatas.currentBoardCanUseList(val)
      this.layoutData = val
      this.form.reactionPlateId = val.id
    }
  },
  created () {
    this.getAbnormalReason()
  }
}

</script>

<style module lang="less">
.LAB_SAMPLES_RECEIVED{
  :global{
    .el-input,
    .el-input__inner {
      width: 280px !important;
    }
  }
}
.specification-table-div {
  margin-bottom: 20px;
  padding: 10px 20px 30px;
}

.specification-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse !important;

  th,
  tr {
    width: 100% !important;
    max-width: 100% !important;
    display: table-row !important;
    padding: 0 !important;
    list-style-type: none;
    justify-content: center !important;
    border-bottom: 1px solid #c6c9d3;
    color: #5b5b5b !important;
  }

  td {
    color: #5b5b5b !important;
    text-align: center;
    justify-content: flex-start !important;
    padding: 10px;
  }
}
</style>
